import React, { useEffect, useRef } from "react";
import code from "../assets/code.svg";
import play from "../assets/play.svg";
import arrow from "../assets/arrow.svg";
import chart from "../assets/chart.svg";
import cloud from "../assets/cloud.svg";
import { Button } from "./Button/Button";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

const DevApi = () => {
  gsap.registerPlugin(ScrollTrigger);

  const ref = useRef(null);

  const timeline = gsap.timeline();

  useEffect(() => {
    const element = ref.current;

    timeline.from(element.querySelector("#left"), {
      duration: 1.5,
      opacity: 1,
      x: -30,
      ease: "none",
      scrollTrigger: {
        trigger: element.querySelector("#dev"),
        start: "80px 100%",
        end: "+=200",
        scrub: true,
      },
    });
    timeline.from(element.querySelector("#right"), {
      duration: 1,
      opacity: 1,
      y: 30,
      delay: 0.8,
      stagger: {
        amount: 0.2,
      },
      ease: "none",
      scrollTrigger: {
        trigger: element.querySelector("#dev"),
        start: "80px 100%",
        end: "+=200",
        scrub: true,
      },
    });
  });
  return (
    <div
      id="security"
      ref={ref}
      className="max-w-[1240px] mx-auto pt-20 md:pt-24 pb-14 px-6 md:px-4"
    >
      <div className="grid sm:grid-cols-2" id="dev">
        <div className="flex flex-col" id="left">
          <div className="mb-8">
            <img src={code} alt="code" />
          </div>
          <div className="flex flex-col lg:flex-row lg:items-center">
            <div className="flex justify-between">
              <Button primary={true} to="/developers">
                Get Started
              </Button>
              <p className="p-4 ml-6 lg:ml-12 border border-[#219563] text-[#219563] text-center w-full hover:-translate-y-1">
                API Documentation
              </p>
            </div>
            <div className="flex flex-row items-center cursor-pointer hover:-translate-y-1 mt-6 md:mt-0 border md:border-none border-[#219653] rounded-md justify-center p-4 w-full">
              <img src={play} alt="play" />
              <p className="ml-2">Watch a demo</p>
            </div>
          </div>
        </div>
        <div
          className="pt-12 sm:ml-6 md:ml-0 sm:pt-0 flex flex-col md:px-8 sm:items-start"
          id="right"
        >
          <h1>Built with love – for developers, by developers</h1>
          <p className="text-justify my-6 md:my-8">
            We're a team of passionate engineers who obsess over sleek, robust,
            and flexible integration. We have made cryptocurrencies transaction
            easy for you with simple integration and clear documentation guides
            to ensure that you can get up and running in no time.
          </p>
          <div className="flex flex-row mb-8">
            <img
              src={chart}
              alt="chart"
              className="px-4 py-4 sm:px-6 sm:py-6 border-solid border border-[#219653] mr-8"
            />
            <img
              src={cloud}
              alt="cloud"
              className="px-4 py-4 sm:px-6 sm:py-6 border-solid border border-[#219653]"
            />
          </div>
          <div className="flex flex-row items-center cursor-pointer hover:-translate-y-1">
            <p className="mr-2">Questions? Talk to an expert</p>
            <img src={arrow} alt="" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DevApi;
